module.exports = __webpack_public_path__ + "static/rain-c-aebecb1e8155cfcbc88d0f7f8bbaba86.jpg";